export default __webpack_public_path__ + "locales/es/InviteDialog.json?hash=8a30702883ca446714ed5fed0a3584df";